// extracted by mini-css-extract-plugin
export var blockBalance = "BlockBalance_blockBalance__nicNf";
export var logo = "BlockBalance_logo__K7eej";
export var textLabel = "BlockBalance_textLabel__0wW+T";
export var rotate = "BlockBalance_rotate__S+OPd";
export var dotty = "BlockBalance_dotty__mPKFz";